import styled from 'styled-components'

export const TopSection = styled.div`
  display: flex;

  > div {
    flex: 1;
  }
`
export const TopSectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const MiddleSection = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  margin-top: 16px;

  > :last-child {
    grid-column: span 2;
  }
`

export const BottomSection = styled.div`
  margin-top: 16px;
  gap: 16px;
  display: grid;
  grid-template-columns: 1fr 1fr;
`
